import React from 'react';
export const SECTION_ID = 'make';

import SvgTextureLineLong from 'js/components/svg/Svg.texture_line_long';

const HeaderRegionMake = ({ title, description, image }) => {
  return (
    <section id={SECTION_ID} className={`header-region header-region--${SECTION_ID}`}>
      <div className="container">
        <div className={`header-region__about-details`}>
          <SvgTextureLineLong color={'#fff'} />
          <h1>{title}</h1>
          <h2>{description}</h2>
        </div>
      </div>
    </section>
  );
};

export default HeaderRegionMake;
